import * as React from 'react';
import { Datagrid, NumberField, List, DateField } from 'react-admin';

export const ShipmentSummary = (props: any) => (
  <List {...props} title="Shipments Summary">
    <Datagrid>
      <DateField source="date" />
      <NumberField source="summary.AT" label="AT" />
      <NumberField source="summary.BE" label="BE" />
      <NumberField source="summary.CZ" label="CZ" />
      <NumberField source="summary.DK" label="DK" />
      <NumberField source="summary.FI" label="FI" />
      <NumberField source="summary.FR" label="FR" />
      <NumberField source="summary.DE" label="DE" />
      <NumberField source="summary.IT" label="IT" />
      <NumberField source="summary.NL" label="NL" />
      <NumberField source="summary.NO" label="NO" />
      <NumberField source="summary.PL" label="PL" />
      <NumberField source="summary.RO" label="RO" />
      <NumberField source="summary.ES" label="ES" />
      <NumberField source="summary.SE" label="SE" />
      <NumberField source="summary.CH" label="CH" />
      <NumberField source="total" label="Total" />
    </Datagrid>
  </List>
);
